import { signify } from "react-signify";

export const sFormData = signify({
  oldPassword: "",
  password: "",
  confirmPassword: "",
});

export const sFormError = signify({
  oldPassword: "",
  password: "",
  confirmPassword: "",
});
